import React from "react";

function CardStack({ icon, img, head }) {
  return (
    <div className="tech-card">
      {icon ? <i className={icon}></i> : <img src={img} alt={head} />}
      <p>{head}</p>
    </div>
  );
}

export default CardStack;